import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import { useLocale } from 'next-intl';

import StyledTags from './tags.style';

const limitArray = (array, limit) =>
  limit ? array.filter((item, index) => index <= limit - 1) : array;

const Tags = ({ tags, limit, listSlug, ...props }) => {
  const locale = useLocale();
  return (
    <StyledTags {...props}>
      <div className="tags__wrapper">
        {tags &&
          limitArray(tags, limit).map(tag =>
            listSlug ? (
              <Link
                href={{
                  pathname: `/${locale}/overview/${listSlug}`,
                  query: { category: listSlug, page: 1, tags: [tag.slug] }
                }}
                as={`/${locale}/${listSlug}?page=1&tags[]=${tag.slug}`}
                key={tag.id}
                className="tags__tag"
              >
                {tag.title}
              </Link>
            ) : (
              <span key={tag.id} className="tags__tag">
                {tag.title}
              </span>
            )
          )}
      </div>
    </StyledTags>
  );
};

Tags.propTypes = {
  limit: PropTypes.number,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  listSlug: PropTypes.string
};

export default Tags;
